import { zIndex } from 'common/constants'
import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'
import { StyledSubMenu } from './SubMenu.styled'

export const StyledMainNav = styled.div<{ show?: boolean; isSticky?: boolean; assetFolder?: string }>`
  display: flex;
  justify-content: center;
  font-size: 1.5rem;
  z-index: ${zIndex.menu};

  .nav-item:hover ${StyledSubMenu} {
    opacity: 1;
    transform: translateY(0);
    pointer-events: initial;
  }

  .nav-link {
    margin: 0 1.5rem;
    font-weight: 400;
    color: ${({ isSticky, theme }) => {
      if (isSticky) {
        return theme.headerSticky.text
      }
      return theme.headerNotSticky.text
    }};

    svg {
      fill: ${({ isSticky, theme }) => {
        if (isSticky) {
          return theme.headerSticky.text
        }
        return theme.headerNotSticky.text
      }};
    }

    .active {
      font-weight: 600;
      color: ${({ isSticky, theme }) => {
        if (isSticky) {
          return theme.headerSticky.textHover
        }
        return theme.headerNotSticky.textHover
      }};
      @media (max-width: ${gridBreakPoints.lg}) {
        color: ${({ theme }) => theme.colors.primary};
      }
    }

    &:hover {
      font-weight: 600;
      color: ${({ isSticky, theme }) => {
        if (isSticky) {
          return theme.headerSticky.textHover
        }
        return theme.headerNotSticky.textHover
      }};
      @media (max-width: ${gridBreakPoints.lg}) {
        color: ${({ theme }) => theme.colors.defaultTextColor}!important;
      }
    }
  }

  @media (max-width: ${gridBreakPoints.xl}) {
    ul {
      .nav-item {
        > .nav-link {
          padding: 0.8rem 0;
        }
      }
    }
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    color: ${({ theme }) => theme.colors.defaultTextColor};
    background-color: ${({ theme }) => theme.colors.mobileMenuBackground};
    position: fixed;
    transform: ${({ show }) => (!!show ? 'translateX(0)' : 'translateX(100%)')};
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${zIndex.navbarMobile};
    min-width: 30rem;
    box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.15);
    transition: all 167ms ease-in;
    overflow-y: auto;
    ul {
      width: 100%;
      display: flex;
      flex-direction: column;
      .nav-item + .nav-item {
        border-top: 0.1rem solid ${({ theme }) => theme.colors.inputBorder};
      }
      .nav-item {
        width: 100%;
        border-top: 0.1rem solid ${({ theme }) => theme.colors.inputBorder};
        border-bottom: 0.1rem ${({ theme }) => theme.colors.defaultTextColor};

        &:hover > .nav-link {
          background-color: white;
        }

        > .nav-link {
          font-size: 1.8rem;
          height: 4rem;
          margin: unset;
          text-align: center;
          color: ${({ theme }) => theme.colors.primary};
          &:hover {
            color: ${({ theme }) => theme.colors.fontColor};
          }
          &.active {
            background: #d4d4d4;
            :after {
              content: none;
            }
          }
        }
      }
    }
  }
`

export const StyledUnderlineSpan = styled.span<{ isSticky?: boolean; assetFolder?: string }>`
  position: relative;
  text-transform: uppercase;
  font-size: 1.5rem;

  /* Reserve space for bold text to prevent layout shift */
  &:before {
    content: attr(data-text);
    font-weight: 600;
    height: 0;
    visibility: hidden;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
    display: block;
    text-transform: uppercase;
    font-size: 1.5rem;
  }

  &.active,
  &:hover {
    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 50%;
      bottom: -0.5rem;
      width: 80%;
      height: 0.4rem;
      background: ${({ isSticky, theme }) => {
        if (isSticky) {
          return theme.headerSticky.spanUnderline
        }
        return theme.headerNotSticky.spanUnderline
      }};
      border-radius: 2.5rem;

      transform: translateX(-50%);
    }
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    &.active,
    &:hover {
      &:after {
        background: ${({ theme }) => theme.colors.primary};
        transform: translateX(-110%);
      }
    }
  }
`
export const StyledNavBar = styled.div<{ show?: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  /* flex-grow: 1; */

  @media (max-width: ${gridBreakPoints.lg}) {
    display: ${({ show }) => (!!show ? 'flex' : 'none')};
  }
`
export const StyledCloseMenuButton = styled.a`
  display: none;
  @media (max-width: ${gridBreakPoints.lg}) {
    display: flex;
    font-size: 2.4rem;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    position: absolute;
    top: 0;
    right: 0;
    width: 3rem;
    height: 3rem;
    align-items: center;
    justify-content: center;
    margin: 0.3rem;
    cursor: pointer;
    font-weight: 600;
    transition: all 167ms ease-in;

    &:hover {
      color: ${({ theme }) => theme.colors.fontColor};
    }
  }
`
export const StyledSubNav = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;

  ul {
    display: none;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    gap: 1.2rem;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    .nav-link {
      font-size: 1.4rem;
      color: ${({ theme }) => theme.colors.defaultTextColor};
      font-weight: 600;
      color: ${({ theme }) => theme.colors.defaultTextColor};
    }

    &.active {
      display: flex;
    }
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    display: none;
  }
`
